<template>
  <div class="more-mobile">
    <TopNavBarMobile :classId="classId" :subjectIndex="subjectIndex" />
    
    <div class="more-content">
      <div class="menu-item" @click="goToManagement">
          <div class="menu-icon management-icon">
            <i class="el-icon-setting"></i>
          </div>
          <div class="menu-info">
            <div class="menu-title">管理</div>
            <div class="menu-desc">班级设置、学生管理、作业管理</div>
          </div>
          <i class="el-icon-arrow-right menu-arrow"></i>
        </div>
        
        <div class="menu-item" @click="goToRollCall">
          <div class="menu-icon rollcall-icon">
            <i class="el-icon-aim"></i>
          </div>
          <div class="menu-info">
            <div class="menu-title">点名</div>
            <div class="menu-desc">随机点名转盘</div>
          </div>
          <i class="el-icon-arrow-right menu-arrow"></i>
        </div>
        
        <div class="menu-item" v-if="isPenaltyOwner" @click="goToPenaltyFree">
          <div class="menu-icon penaltyfree-icon">
            <i class="el-icon-medal"></i>
          </div>
          <div class="menu-info">
            <div class="menu-title">不罚</div>
            <div class="menu-desc">罚站记录管理</div>
          </div>
          <i class="el-icon-arrow-right menu-arrow"></i>
        </div>

        <div class="menu-item" @click="goToFingerGuide">
          <div class="menu-icon finger-icon">
            <i class="el-icon-document"></i>
          </div>
          <div class="menu-info">
            <div class="menu-title">新手指引</div>
            <div class="menu-desc">系统使用说明</div>
          </div>
          <i class="el-icon-arrow-right menu-arrow"></i>
        </div>
        
        <div class="menu-item logout-item" @click="handleLogout">
          <div class="menu-icon logout-icon">
            <i class="el-icon-switch-button"></i>
          </div>
          <div class="menu-info">
            <div class="menu-title">退出登录</div>
            <div class="menu-desc">退出当前账号</div>
          </div>
          <i class="el-icon-arrow-right menu-arrow"></i>
        </div>
    </div>
    
    <FingerGuideDialog ref="fingerGuideDialog" />
  </div>
</template>

<script>
import TopNavBarMobile from '@/components/mobile/TopNavBarMobile.vue'
import FingerGuideDialog from '@/components/FingerGuideDialog.vue'
import logoutMixin from '@/mixins/logoutMixin.js'

export default {
  name: 'MoreMobile',
  mixins: [logoutMixin],
  components: {
    TopNavBarMobile,
    FingerGuideDialog
  },
  props: {
    classId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      subjectIndex: 0,
      isPenaltyOwner: false
    }
  },
  created() {
    this.loadSubjectIndex();
    this.checkPenaltyOwner();
    document.body.classList.remove('chinese-theme', 'math-theme', 'english-theme');
  },
  methods: {
    checkPenaltyOwner() {
      try {
        const teacherInfo = JSON.parse(localStorage.getItem('teacherInfo') || '{}');
        this.isPenaltyOwner = teacherInfo.phone === '13211069219';
      } catch (e) {
        this.isPenaltyOwner = false;
      }
    },
    goToPenaltyFree() {
      this.$router.push(`/mobile/penalty/${this.classId}`);
    },
    loadSubjectIndex() {
      const savedState = sessionStorage.getItem('mobileNavState');
      if (savedState) {
        try {
          const state = JSON.parse(savedState);
          this.subjectIndex = state.subjectIndex || 0;
        } catch (e) {
          this.subjectIndex = 0;
        }
      }
    },
    goToFingerGuide() {
      this.$refs.fingerGuideDialog.open()
    },
    goToManagement() {
      this.$router.push(`/mobile/management/${this.classId}`);
    },
    goToRollCall() {
      this.$router.push(`/mobile/rollcall/${this.classId}`);
    },
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', { type: 'warning' }).then(() => {
        this.logoutAndRedirect('/loginmobile');
      }).catch(() => {});
    }
  }
}
</script>

<style scoped>
.more-mobile {
  min-height: 100vh;
  background: #f5f7fa;
  padding-top: 44px;
}

.more-content {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.menu-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.menu-item {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: all 0.3s ease;
}

.menu-item:active {
  transform: scale(0.98);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.menu-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
  flex-shrink: 0;
}

.menu-icon.management-icon {
  background: linear-gradient(135deg, #40e0d0, #6abfd1);
}

.menu-icon.penaltyfree-icon {
  background: linear-gradient(135deg, #36cfc9, #40e0d0);
}

.menu-icon.finger-icon {
  background: linear-gradient(135deg, #ff8c00, #ffad33);
}

.menu-icon.rollcall-icon {
  background: linear-gradient(135deg, #409EFF, #6abfd1);
}

.menu-icon.logout-icon {
  background: linear-gradient(135deg, #f56c6c, #e64545);
}

.menu-icon i {
  font-size: 24px;
  color: #fff;
}

.menu-info {
  flex: 1;
}

.menu-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 4px;
}

.menu-desc {
  font-size: 12px;
  color: #909399;
}

.menu-arrow {
  font-size: 16px;
  color: #c0c4cc;
}
</style>
